<template>
  <div
    id="manning-schedule-vesels-container"
    class="manning-schedule-vesels-wrap"
  >
    <scheduler-project-model
      ref="projectmodel"
      :hasScheduleChangedAsync="SchedulerEventHandler"
      :syncSuccessAsync="syncSuccessAsync"
      :syncFailAsync="syncFailAsync"
      :loadFailAsync="loadFailAsync"
      :eventStore="VesselEventStore"
      :resourceStore="VesselResourceStore"
      :assignmentStore="VesselAssignmentStore"
      :timeRangeStore="VesselTimeRangeStore"
      :transport="transport"
    />

    <!-- スケジューラPro -->
    <bryntum-scheduler-pro
      v-if="schedulerConfig && columns"
      v-bind="schedulerConfig"
      cls="aisea-scheduler"
      :autoCreate="false"
      :scheduleContextFeature="scheduleContextFeature"
      :taskEditFeature="taskEditFeature"
      :eventTooltipFeature="eventTooltipFeature"
      :eventMenuFeature="eventMenuFeature"
      :eventLayout="eventLayout"
      :eventRenderer="eventRenderer"
      :tree-summary-feature="treeSummaryFeature"
      :listeners="listeners"
      :project="project"
      :tbar="tbar"
      :columns="columns"
      ref="scheduler"
    >
    </bryntum-scheduler-pro>
    <!-- 船員選択ドロワー -->
    <assignable-crews ref="assignableCrews" @crewSelected="crewSelected" />
    <manning-vessel-crew-info ref="manningVesselCrewInfo" />
  </div>
</template>
<script>
import { BryntumSchedulerPro } from "@bryntum/schedulerpro-vue";
import { LocaleManager, LocaleHelper } from "@bryntum/schedulerpro";
import "@bryntum/schedulerpro/locales/schedulerpro.locale.Ja.js";

import moment from "moment";

import C from "../Constants";
import transport from "./Transport";

import {
  VesselEventModel,
  VesselEventStore,
  VesselResourceStore,
  VesselAssignmentStore,
  VesselTimeRangeStore,
} from "./scheduler-stores";

import { createSchedulerConfig } from "../scheduler-config/vessel";

import Toolbar from "../components/scheduler/Toolbar";
import Columns from "./components/scheduler/Columns";
import EventTooltipFeature from "../components/scheduler/features/EventTooltipFeature";
import EventRenderer from "../components/scheduler/renderer/EventRenderer";
import { ViewPresetsHandler } from "../scheduler-config/viewPreset";
// マスターデータのサービス
import {
  // 船員情報マスター
  EnterpriseCrewsService,
  // 船舶情報マスター
  EnterpriseManningVesselsService,
  // 船員役割マスター
  EnterpriseCrewRoleService,
  // 配乗スコアリングカテゴリーマスター
  EnterpriseAssignmentScoringCategoriesService,
  // 船員基本条件マスター
  EnterpriseCrewsBasicConditionsService,
  // 船員配乗アラート設定サービス
  EnterpriseCrewAlertSettingsService,
  // 年度設定マスタサービス
  EnterpriseCrewsFiscalYeatDefaultsService,
  // 配乗船舶カテゴリーマスター
  ManningVesselCategoryService,
} from "../services/master";

import { CrewFilterService } from "../services/vessels/CrewFilterService";

import SchedulerEventHandler from "../scheduler-edit-event-handler";
import EventHelperVessel from "../scheduler-event-helper/vessel";

import SchedulerProjectModel from "../SchedulerProjectModel.vue";
import AssignableCrews from "./components/assignable-crews/AssignableCrews.vue";
import ManningVesselCrewInfo from "../components/manning-vessel-crew-info/ManningVesselCrewInfo.vue";
import { getVisibleDate } from "../utils/SchedulerUtil";
import CustomTaskEdit from "./components/scheduler/CustomTaskEdit";

export default {
  name: "Vessels",
  components: {
    BryntumSchedulerPro,
    SchedulerProjectModel,
    AssignableCrews,
    ManningVesselCrewInfo,
  },
  data() {
    return {
      SchedulerEventHandler: SchedulerEventHandler(C.DISPLAY_MODE.VESSEL),
      // 現在日時
      nowDate: null,
      // スケジューラ設定
      schedulerConfig: null,
      // 入替船員未登録アラート設定 moutedでマスターから取得
      unregisterdAlertSetting: null,
      currentStartDate: null,
      currentEndDate: null,
      // Project設定
      project: null,
      transport: transport,
      // 年度選択
      selectedYear: null,
      // ヘッダーのツールバー表示設定
      tbar: null,
      // リソース列表示設定
      columns: null,
      columnsSource: null,
      // スケジューラのイベントレンダラー
      eventRenderer: null,
      // スケジューラのイベントリスナー
      listeners: {
        beforeTaskEditShow: CustomTaskEdit.handleBeforeTaskEditShow,
        // ツリー開閉前イベント
        // ツリー開閉イベント
        toggleNode: async () => {
          await this.fillUnregisterdCrewAlertAreasAsync();
        },
        // ツリー開閉前イベント
        // こちらで、timeRangeのハイライトを解除しないとエラーになる
        beforeToggleNode: async () => {
          await this.$refs.scheduler.instance.unhighlightTimeSpans();
        },
      },
      // イベント表示設定
      eventLayout: {
        type: "stack",
        groupBy: "scheduling_status",
        weights: {
          SCHEDULED: 0,
          PLANNING: 1,
        },
      },
      // スコア表示設定
      treeSummaryFeature: {
        disabled: false,
        renderer: () => {
          const empty = "";
          return {
            text: empty,
          };
        },
      },
      // スケジューラのセル設定
      // セルをマウスオーバしたときに、「+」アイコンを表示
      // クリックした時に、船員選択ドロワーを表示
      scheduleContextFeature: {
        activateOnEvent: true,
        triggerEvent: "hover",
        widget: {
          type: "button",
          cls: "context-button b-blue b-transparent",
          icon: "b-fa b-fa-plus",
          onClick: this.cellClicked,
        },
      },
      // イベントを右クリックしたときのメニュー表示設定
      // weightはメニューの表示順
      eventMenuFeature: {
        items: {
          editVesselInfo: {
            text: "乗船情報編集",
            icon: "b-fa b-fa-ship",
            onItem: ({ eventRecord }) => {
              this.$refs.manningVesselCrewInfo.open(
                eventRecord,
                this.manningVessels,
                this.crews
              );
            },
            weight: 1,
          },
          editEvent: {
            text: "期間編集",
            icon: "b-fa b-fa-edit",
            weight: 2,
          },
          deleteEvent: {
            text: "削除",
            icon: "b-fa b-fa-trash",
            weight: 3,
            onItem: ({ eventRecord }) => {
              // イベントストアを取得
              const scheduler = this.$refs.scheduler.instance;
              const eventStore = scheduler.eventStore;

              // 予定イベントの削除は確認ダイアログを表示
              if (
                eventRecord.scheduling_status === C.SCHEDULING_STATUS.SCHEDULED
              ) {
                this.$vs.dialog({
                  type: "confirm",
                  color: "danger",
                  title: "スケジュールの削除",
                  text: "削除しますがよろしいですか",
                  cancelText: "キャンセル",
                  acceptText: "OK",
                  accept: () => {
                    // 予定イベントの削除
                    eventStore.remove(eventRecord);
                  },
                });
              } else {
                // 予定以外のイベントは確認なしで削除
                eventStore.remove(eventRecord);
              }
            },
          },
          splitEvent: false,
          cutEvent: false,
          copyEvent: false,
          unassignEvent: false,
        },
      },
      // イベントマウスオーバ時のツールチップ表示設定
      eventTooltipFeature: {},
      // イベント編集モーダル設定
      taskEditFeature: CustomTaskEdit.buildCustomTaskEdit(),
      manningVessels: [],
      crews: [],
    };
  },
  setup() {
    return {
      VesselEventStore,
      VesselResourceStore,
      VesselAssignmentStore,
      VesselTimeRangeStore,
    };
  },
  methods: {
    /**
     * スケジューラのセルクリックイベント
     */
    async cellClicked() {
      // クリックしたセルのリソースと日付を取得
      // 船員選択ドロワーに渡して、開く
      const timelineContext = this.$refs.scheduler.instance.timelineContext;
      const resourceRecord = timelineContext.resourceRecord;
      const selectedDate = timelineContext.date;
      this.$refs.assignableCrews.open(resourceRecord, selectedDate);
    },
    /**
     * 船員選択ドロワーの船員選択イベント
     * @param {Object} assignableCrews 配乗可能船員情報
     * @param {Object} resource リソース情報
     * @param {Date} date 日付
     */
    crewSelected(assignableCrews, resource, date) {
      // クリックした日付の会計年度を取得
      const fiscalYear = EnterpriseCrewsBasicConditionsService.getFiscalYear(
        date
      );

      // 基本乗船日数を取得
      // もし取得できなければ、年度デフォルト値を取得
      let basicBoardingDays = EnterpriseCrewsService.getBasicBoardingDaysByFiscalYear(
        assignableCrews.crew_id,
        fiscalYear
      );
      if (!basicBoardingDays) {
        basicBoardingDays = EnterpriseCrewsFiscalYeatDefaultsService.getBasicBoardingDays(
          fiscalYear
        );
      }
      // 基本乗船日数が取得できなければ、0を設定
      if (!basicBoardingDays) {
        basicBoardingDays = 0;
      }

      // イベントの開始日と終了日を設定
      const startDate = date;
      const endDate = moment(date)
        .add(basicBoardingDays, "days")
        .toDate();

      // 選択した船員でイベントモデルを作成
      // イベント編集モーダルを表示
      const scheduler = this.$refs.scheduler.instance;
      const eventStore = scheduler.eventStore;
      const eventModel = new VesselEventModel(
        {
          crew_id: assignableCrews.crew_id,
          startDate: startDate,
          endDate: endDate,
          scheduling_status: C.SCHEDULING_STATUS.PLANNING,
          phantom_group_key: `gk_${window.crypto.randomUUID()}`,
        },
        eventStore
      );
      this.$refs.scheduler.instance.editEvent(eventModel, resource);
    },
    /**
     * 年度が変更されたときの処理
     * @param {number} year 選択された年度
     */
    async onFiscalYearChange(year) {
      // 年度が変更されたときの処理
      this.selectedYear = year;
      // スケジューラのデータを再読み込み
      await this.reloadData();
    },

    /**
     * 入替船員未登録アラートのハイライトエリアを設定
     * @returns {Promise<void>}
     */
    async fillUnregisterdCrewAlertAreasAsync() {
      const scheduler = this.$refs.scheduler.instance;

      // 未船員配乗アラートのハイライトを設定
      const highlightTimeSpans = EventHelperVessel.createUnregisterdCrewAlertTimeSpan(
        this.project.instance,
        this.unregisterdAlertSetting,
        "highlight-caution",
        "highlight-warning",
        this.nowDate
      );

      // 警戒、注意エリア塗り設定追加
      await scheduler.highlightTimeSpans(highlightTimeSpans);
    },

    /**
     * スケジューラの同期成功時の処理
     * こちらはSchedulerProjectModelから呼び出されるイベントハンドラ
     * @returns {Promise<void>}
     */
    async syncSuccessAsync() {
      // setTimeoutが無いとサーバー同期後にハイライトが上手く反映されない。
      setTimeout(async () => {
        // アラートのハイライトエリアを再設定
        await this.fillUnregisterdCrewAlertAreasAsync();
      }, 0);
    },

    /**
     * スケジューラの同期失敗時の処理
     * こちらはSchedulerProjectModelから呼び出されるイベントハンドラ
     * @param {Object} response レスポンスオブジェクト
     */
    async syncFailAsync(response) {
      // 同期失敗時の処理
      const text =
        response && response.message
          ? response.message
          : "データを更新できませんでした。再読込みして下さい。";
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "更新に失敗しました",
        text: text,
        buttonCancel: true,
        acceptText: "再読込み",
        accept: async () => {
          // ページをリロード
          await this.reloadData();
        },
      });
    },

    /**
     * スケジューラのロード失敗時の処理
     * こちらはSchedulerProjectModelから呼び出されるイベントハンドラ
     * @param {Object} response レスポンスオブジェクト
     */
    async loadFailAsync() {
      // ロード失敗時の処理
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "システムエラー",
        text: "システムエラーが発生しました。管理者へお問い合わせください。",
        buttonCancel: true,
        acceptText: "OK",
      });
    },

    async reloadData() {
      // 既存のハイライトを解除
      // ここで解除しないとエラーになる
      await this.$refs.scheduler.instance.unhighlightTimeSpans();

      // スケジューラのデータを取得
      this.project = this.$refs.projectmodel.project;
      const projectInstance = this.project.instance;

      const res = await projectInstance.load({
        request: {
          params: {
            fiscal_year: this.selectedYear,
          },
        },
      });

      // 再ロードしてもカレンダーが変わらないので、再設定
      const { startDate, endDate } = res.response.project;
      this.currentStartDate = startDate;
      this.currentEndDate = endDate;
      await this.$refs.scheduler.instance.setTimeSpan(
        this.currentStartDate,
        this.currentEndDate
      );

      // 全リソース展開
      await this.$refs.scheduler.instance.expandAll();

      // 警戒・注意アラートをハイライト
      await this.fillUnregisterdCrewAlertAreasAsync();

      // 年度ラベルを更新
      this.$refs.scheduler.instance.widgetMap.yearLabel.value = this.selectedYear;

      // vesselsのデータを再取得
      this.manningVessels = await EnterpriseManningVesselsService.fetch();
      // 船員フィルター作成
      const crewFilterData = CrewFilterService.createFilterData(
        VesselResourceStore.data,
        EnterpriseManningVesselsService.getEnterpriseManningVessels()
      );
      // 船員フィルターの適用
      this.columnsSource.applyCrewFilter(crewFilterData, VesselResourceStore);
    },
  },

  async created() {
    // スケジューラの設定を作成
    this.schedulerConfig = createSchedulerConfig();
    // スケジューラプロのローカライズ設定
    LocaleManager.locale = LocaleHelper.locales.Ja;

    this.columnsSource = Columns(this);
    this.columns = this.columnsSource.build();
  },

  async mounted() {
    // 現在日時を設定
    this.nowDate = new Date();

    // マスターデータの読み込み
    // 失敗した場合はダイアログを表示して、ページをリロードする。
    try {
      await Promise.all([
        (this.crews = await EnterpriseCrewsService.fetch()),
        (this.manningVessels = await EnterpriseManningVesselsService.fetch()),
        await EnterpriseCrewRoleService.fetch(),
        await EnterpriseAssignmentScoringCategoriesService.fetch(),
        await EnterpriseCrewsBasicConditionsService.fetch(),
        await EnterpriseCrewAlertSettingsService.fetch(),
        await EnterpriseCrewsFiscalYeatDefaultsService.fetch(),
        await ManningVesselCategoryService.fetch(),
      ]);
    } catch (e) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "システムエラー",
        text: "システムエラーが発生しました。管理者へお問い合わせください。",
        buttonCancel: true,
        acceptText: "OK",
      });
      return;
    }

    // アラートマスターから、未船員配乗アラート設定を取得
    this.unregisterdAlertSetting = EnterpriseCrewAlertSettingsService.findSettingBykind(
      C.ENTERPRISE_CREW_ALERT_KIND.REPLACEMENT_CREW_NOT_ASSIGNED
    );

    // 表示年度を設定してから、ツールバーを作成
    // 初回は現在の年度を設定する。
    const fisicalYear = EnterpriseCrewsBasicConditionsService.getFiscalYear(
      this.nowDate
    );
    this.selectedYear = fisicalYear;
    // 配乗表 人単位のリンク
    const url = this.$router.resolve({
      name: "addon-crew-assignment-management-manning-schedule-crews",
    }).href;
    // SchedulrtProのツールバーを作成
    const viewPresetsHandler = ViewPresetsHandler(this);
    const toolbar = Toolbar(
      "船舶単位 配乗表",
      this.selectedYear,
      "人単位",
      url,
      {
        onFiscalYearChange: this.onFiscalYearChange,
        onReloadClicked: this.reloadData,
        // カレンダースケールが変更されたときの処理
        onScaleChange: async presetId => {
          await viewPresetsHandler.onScaleChange(
            this.currentStartDate,
            this.currentEndDate,
            presetId
          );
        },
      }
    );
    this.tbar = toolbar.build();
    // イベントのツールチップ表示設定
    this.eventTooltipFeature = EventTooltipFeature().build();
    // イベントレンダラー設定
    this.eventRenderer = EventRenderer(C.DISPLAY_MODE.VESSEL).build();

    // データ読み込み
    await this.reloadData();

    // 現在時刻の線を表示
    this.project.instance.applyChangeset({
      timeRanges: {
        added: [
          {
            id: "nowDate",
            startDate: moment(this.nowDate).format(),
            cls: "b-circle",
          },
        ],
      },
    });

    // カレンダーの初期表示位置の設定
    const visibleDate = getVisibleDate(this.currentStartDate, this.nowDate, 20);
    this.$refs.scheduler.instance.visibleDate = visibleDate;

    // 船員フィルター作成
    const crewFilterData = CrewFilterService.createFilterData(
      VesselResourceStore.data,
      EnterpriseManningVesselsService.getEnterpriseManningVessels()
    );
    // 船員フィルターの適用
    this.columnsSource.applyCrewFilter(crewFilterData, VesselResourceStore);
  },
};
</script>
<style lang="scss" scoped>
@import "~@bryntum/schedulerpro/schedulerpro.stockholm.css";

.manning-schedule-vesels-wrap {
  left: 0px;
  right: 0px;
  top: 0px;
  height: 100vh;
  position: absolute;
}

.manning-schedule-vesels-wrap {
  :deep(.b-sch-event-content) {
    right: 0.75em !important;
    margin-left: auto !important;
  }

  /* カレンダーの土日色 */
  :deep(.calendar-saturday) {
    background-color: #b8b8ff;
    color: #fff;
  }

  :deep(.calendar-sunday) {
    background-color: #ffb8b8;
    color: #fff;
  }

  /* 現在日時線 */
  :deep(.b-grid-header .b-sch-line.b-circle.b-sch-timerange) {
    background-color: #ff0000;
    height: 0.8em !important;
    width: 0.8em !important;
    border-radius: 50%;
    margin-inline-start: -0.43em;
    bottom: 0;
    padding: 0;
  }

  :deep(.b-timeline-subgrid .b-sch-line.b-circle) {
    border-left: 2px solid #ff00003a;
  }

  /* 未船員配乗アラート 警戒・注意色 */
  :deep(.highlight-warning) {
    background-color: #f7baba;
    border: #ff00003a 1px dashed;
  }

  :deep(.highlight-caution) {
    background-color: #f5ef74;
    border: rgba(245, 236, 64, 0.341) 1px dashed;
  }

  :deep(.year-label) {
    width: 100px;
    height: 42px;
    font-size: 14px;
    color: #4f5964;
    background-color: white;
    border: rgb(208, 209, 210) solid 1px;
    border-radius: 2px;

    span {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  :deep(.scale-text-combo) {
    text-align: center;
    justify-content: center;
  }
}
</style>
